import React from 'react';
import styled from "styled-components";
import Spider from "../assets/agile_spider.png";
import STM from "../assets/systemic.png";
import {useState} from "react";
import {device} from "../components/Devices";


function Agile() {

    const [activeDetails, setActiveDetails] = useState("agile");


    return (

        <Main_Agile_Container>
            <div className="intro_agile">
                <h1>Agile Knowl<span>edge</span></h1>
                <p>I have been working in Agile environments for years now and have been in many transitions and diverse
                    roles. During my Agile Coaching training I liked describing my knowledge with Lyssa Adkins Agile
                    Spider <span>click the picture to find out more</span></p>
            </div>

            <section className="info_section">
                <aside className="spider">
                    <aside className="image_container">
                        <img src={Spider} alt=""/>
                        <div className="grid_container_A">
                            <div className="grid_item_A" onClick={() => setActiveDetails("teaching")}></div>
                            <div className="grid_item_B" onClick={() => setActiveDetails("agile")}></div>
                            <div className="grid_item_A" onClick={() => setActiveDetails("coaching")}></div>
                        </div>
                        <div className="grid_container_B">
                            <div className="grid_item_B" onClick={() => setActiveDetails("mentoring")}></div>
                            <div className="grid_item_B" onClick={() => setActiveDetails("facilitating")}></div>
                        </div>
                        <div className="grid_container_C">
                            <div className="grid_item_C" onClick={() => setActiveDetails("technical")}></div>
                            <div className="grid_item_C" onClick={() => setActiveDetails("business")}></div>
                            <div className="grid_item_C" onClick={() => setActiveDetails("transformation")}></div>
                        </div>
                    </aside>

                    <article>
                        {activeDetails === "teaching" &&
                            <div>
                                <h2>Teaching</h2>
                                <p>When teams are at the beginning of their learning curve in Agile they need knowledge
                                    on how
                                    to do their work in this context, As agile coach you should focus on sharing this
                                    knowledge
                                    by teaching the methods. I have set up training courses and have given several
                                    training
                                    sessions myself.</p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>

                        }

                        {activeDetails === "agile" &&
                            <div>
                                <h2>Agile & Lean Practitioner</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }

                        {activeDetails === "coaching" &&
                            <div>
                                <h2>Professional Coaching</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }

                        {activeDetails === "mentoring" &&
                            <div>
                                <h2>Mentoring</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }

                        {activeDetails === "facilitating" &&
                            <div>
                                <h2>Facilitating</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }

                        {activeDetails === "technical" &&
                            <div>
                                <h2>Technical Mastery</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }

                        {activeDetails === "business" &&
                            <div>
                                <h2>Business Mastery</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }

                        {activeDetails === "transformation" &&
                            <div>
                                <h2>Transformation Mastery</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias odit possimus
                                    sint? Animi
                                    aut
                                    commodi culpa cumque, distinctio dolor dolore enim expedita explicabo fugit
                                    laboriosam
                                    magnam
                                </p>

                                <aside className="stars">
                                    <span>Expert Rate: </span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                </aside>

                            </div>
                        }
                    </article>
                </aside>

                <aside className="systemic">

                    <aside className="stm_picture">
                        <img src={STM} alt=""/>

                    </aside>

                    <div>

                        <h2>Systemic Transition Management</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus amet, autem commodi
                            dignissimos dolore dolorum eius expedita fuga fugiat harum iusto laborum maxime, minus modi
                            molestiae nesciunt non nulla obcaecati odit possimus praesentium quia quibusdam rerum soluta
                            suscipit, unde voluptatum! Amet ducimus eaque ipsa iste iusto laboriosam? Alias, maiores
                            qui?</p>
                    </div>


                </aside>
            </section>


        </Main_Agile_Container>

    );
}

export default Agile;

const Main_Agile_Container = styled.div`

  height: auto;
  min-height: 964px;
  background-color: transparent;
  margin-top: 100px;

  display: flex;
  flex-direction: column;
  align-items: center;
  //border: 1px solid black;

  width: auto;
  min-width: 320px;
  max-width: 320px;

  @media ${device.mobileM} {
    max-width: 375px;
  }

  @media ${device.mobileL} {
    max-width: 425px;
  }

  @media ${device.tablet} {
    max-width: 768px;
  }

  @media ${device.laptop} {
    width: 1024px;
    max-width: 1024px;
  }

  @media ${device.laptopL} {
    width: 1400px;
    max-width: 1440px;

  }

  .intro_agile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 300px;
    //border: 1px solid black;

    @media ${device.mobileM} {
      width: auto;
      margin: 0 8px;
    }

    @media ${device.laptopL} {
      margin: 0 30px;

    }


    h1 {
      color: var(--mainTextColor);
      font-weight: lighter;
      margin-bottom: 20px;

      @media ${device.tablet} {
        margin-top: 50px;
        margin-bottom: 20px;
      }

      @media ${device.laptopL} {
        margin-top: 100px;

      }

      span {
        border-bottom: 2px solid var(--orange);
      }
    }

    p {
      color: var(--blackShadow);
      line-height: 22px;
      font-weight: lighter;
      font-size: 20px;

      @media ${device.tablet} {
        font-size: 25px;
        line-height: 30px;
      }

      span {
        color: var(--orange);
      }
    }
  }

  .info_section {

    display: flex;
    flex-direction: column;
    align-items: center;
    //border: 1px solid var(--orange);

    width: auto;
    min-width: 320px;
    max-width: 320px;

    @media ${device.mobileM} {
      max-width: 375px;
    }

    @media ${device.mobileL} {
      max-width: 425px;
    }

    @media ${device.tablet} {
      max-width: 768px;
    }

    @media ${device.laptopL} {
      width: 1400px;
      max-width: 1440px;
      flex-direction: row;
      justify-content: center;
      align-items: flex-start;
      margin: 20px;
      

    }

    .spider {

      width: auto;
      height: 100%;
      min-height: 100%;
      //border: 1px solid orange;
      display: flex;
      flex-direction: column;
      align-items: center;

      @media ${device.laptopL} {
        max-width: 1400px;
        margin-right: 20px;


      }

      .image_container {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        //border: 1px solid orange;
        width: auto;
        max-width: 390px;
        height: 300px;

        margin-top: 20px;

        @media ${device.mobileL} {
          max-width: 420px;
        }

        @media ${device.tablet} {
          max-width: 600px;
        }

        @media ${device.laptopL} {
          max-width: 1400px;

        }

      }

      img {
        width: 360px;
        height: 280px;
        position: absolute;
        //margin-top: 150px;

        @media ${device.mobileL} {
          width: 410px;
        }

        @media ${device.tablet} {
          width: 500px;
          height: 300px;

        }

        @media ${device.laptopL} {
          widht: 700px;

        }


      }

      .grid_container_A {

        display: flex;

        //margin-top: 120px;
        //border: 1px solid orange;
        position: absolute;
        width: 390px;
        max-width: 390px;
        height: 120px;


        .grid_item_A {
          width: 40px;
          min-width: 120px;
          height: 120px;
          //border: 1px solid orange;
          cursor: pointer;
        }

        .grid_item_B {
          width: 300px;
          min-width: 120px;
          height: 100px;
          //border: 1px solid orange;
          cursor: pointer;

        }

      }

      .grid_container_B {

        display: flex;

        margin-top: 120px;
        //border: 1px solid orange;
        position: absolute;
        width: 390px;
        max-width: 390px;
        height: 120px;


        .grid_item_B {
          margin-bottom: 20px;
          width: 300px;
          min-width: 60px;
          height: 60px;
          //border: 1px solid orange;
          cursor: pointer;
        }

      }

      .grid_container_C {
        display: flex;

        margin-top: 180px;
        //border: 1px solid orange;
        position: absolute;
        width: 390px;
        max-width: 390px;
        height: 100px;

        .grid_item_C {
          margin-bottom: 20px;
          width: 125px;
          min-width: 60px;
          height: 100px;
          //border: 1px solid orange;
          cursor: pointer;
        }

      }

      article {

        position: relative;
        //border: 1px solid var(--orange);
        width: auto;
        margin-top: 4px;
        

        div {
          
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          width: 320px;
          //border: 1px solid var(--orange);
          padding: 5px;
          background-color: var(--blackShadow);
          max-height: 350px;
          overflow-x: hidden;
          overflow-y: scroll;

          @media ${device.mobileM} {
            margin: 0 8px;
            width: 360px;
          }

          @media ${device.mobileL} {
            margin: 0 8px;
            width: 410px;
          }

          @media ${device.tablet} {
            margin-top: 20px;
            width: 500px;

          }

          @media ${device.laptopL} {
            max-width: 500px;
            height: 348px;
            max-height: 400px;
          }


          h2 {
            color: var(--mainTextColor);
            font-weight: lighter;
            margin-bottom: 5px;
            @media ${device.tablet} {

              font-size: 30px;
              margin-bottom: 20px;
            }

          }

          p {
            color: var(--dimGrey);
            line-height: 22px;
            font-weight: lighter;
            font-size: 20px;

            @media ${device.tablet} {

              margin-bottom: 20px;
              font-size: 25px;
              line-height: 30px;
            }

          }
        }

      }

      .stars {

        display: flex;

        .fa {
          margin-left: 3px;
          font-size: 14px;
          color: var(--mainTextColor);
        }

        .checked {
          color: var(--orange);
        }

      }
    }

    .systemic {

      margin-top: 20px;
      //border: 1px solid blue;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 320px;
      

      @media ${device.mobileM} {
        width: 360px;
      }


      @media ${device.mobileL} {
        width: 410px;
      }

      @media ${device.tablet} {
        width: 500px;
        

      }

      @media ${device.laptopL} {
        widht: 700px;
        
      }

      .stm_picture {

        img {
          width: 100%;
          height: 100%;

          @media ${device.laptopL} {
            width: 500px;
            height: 300px;


          }
          
        }
      }

      div {

        margin-top: 20px;
        background-color: var(--blackShadow);
        width: auto;
        height: 100%;
        padding: 5px;
        
        
        h2 {
          color: var(--mainTextColor);
          font-weight: lighter;
          margin-bottom: 5px;

          @media ${device.tablet} {

            font-size: 30px;
            margin-bottom: 20px;
          }

        }

        p {
          color: var(--dimGrey);
          line-height: 22px;
          font-weight: lighter;
          font-size: 20px;

          @media ${device.tablet} {

            margin-bottom: 20px;
            font-size: 25px;
            line-height: 30px;
          }

        }

      }

      

    }

  }





`;